// A studio picks its own colour, and some are light: a sand, a yellow, a soft
// orange. White text on those can't be read, and neither can the colour itself
// used as text on a white page. These say which ink goes with a colour, so a
// public page stays readable whatever the studio chose.

const INK = "#1a1a1a";

const rgb = (hex) => {
  const m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(String(hex || "").trim());
  if (!m) return null;
  const h = m[1].length === 3 ? m[1].split("").map((c) => c + c).join("") : m[1];
  return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
};

const channel = (v) => {
  const c = v / 255;
  return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
};

const luminance = (hex) => {
  const c = rgb(hex);
  return c ? 0.2126 * channel(c[0]) + 0.7152 * channel(c[1]) + 0.0722 * channel(c[2]) : 0;
};

// Light means white text on it falls under 3:1, the floor for a button label.
export const isLightBrand = (hex) => 1.05 / (luminance(hex) + 0.05) < 3;

// The text colour that reads on top of the brand colour.
export const onBrand = (hex) => (isLightBrand(hex) ? INK : "#fff");

// The brand colour as text on a white page, or plain ink when it is too pale.
export const brandInk = (hex) => (isLightBrand(hex) ? INK : hex);

// The brand colour moved part of the way toward another colour, for a darker
// edge on a gradient or a pale tint behind a day that is open.
export const mix = (hex, toward, amount) => {
  const a = rgb(hex);
  const b = rgb(toward);
  if (!a || !b) return hex;
  return `#${a.map((v, i) => Math.round(v + (b[i] - v) * amount).toString(16).padStart(2, "0")).join("")}`;
};
